"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { ScrollableFlowScreen } from "../UI/ScrollableFlowScreen";
import { SearchResultsDemo } from "../Demos/DeepActionFlow/InteractionDemos/SearchResultsDemo";
import Image from "next/image";

interface DeepSearchSectionProps {
  onDownloadClick?: () => void;
}

export function DeepSearchSection({ onDownloadClick }: DeepSearchSectionProps) {
  const searchRef = useRef<HTMLDivElement>(null);

  // Use the demo container ref for text scroll progress to ensure perfect sync
  const { scrollYProgress } = useScroll({
    target: searchRef,
    offset: ["start center", "end end"],
  });

  const searchTexts = [
    "Fellou automates deep research across the entire internet, including logged-in accounts on platforms like Reddit, generating personalized and in-depth reports with verifiable sources",
  ];

  // 第二阶段"Still opening..." 文本显示 (0.7-1.0, 占总进度30%)
  const stillTextOpacity = useTransform(scrollYProgress, [0.7, 0.75, 0.9, 1.0], [0, 1, 1, 1]);

  return (
    <div>
      <ScrollableFlowScreen ref={searchRef} onViewportEnter={() => console.log("Deep Search entered")} compact={true}>
        <div className="flex min-h-[400vh]">
          {/* Left Half - Progressive Text Display */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <motion.div className="max-w-[600px] space-y-12">
              <h2 className="text-4xl font-bold text-white mb-8">
                <div className="w-full">Automate Multi-Source Research </div> into Traceable Reports
              </h2>
              {searchTexts.map((text, index) => (
                <div key={index} className="text-2xl font-medium text-white leading-relaxed">
                  {text}
                </div>
              ))}

              {/* Still Text - 第二阶段文本显示 (0.5-1.0) */}
              <motion.div className="space-y-8" style={{ opacity: stillTextOpacity }}>
                <div className="text-3xl font-bold text-white/90 leading-tight">
                  <div className="flex items-center gap-2 mb-4">Still opening 10 tabs?</div>
                  <div className="flex items-center gap-2">
                    <div className="relative flex-shrink-0 size-8">
                      <Image
                        src="/favicon.ico"
                        alt="fellou"
                        fill
                        priority
                        unoptimized
                        className="rounded p-0.5 ring-1 ring-white/20"
                      />
                    </div>
                    <div>Fellou searches deep, finds fast.</div>
                  </div>
                </div>
              </motion.div>
            </motion.div>
          </div>

          {/* Right Half - Browser Windows Wireframe (Sticky) */}
          <div className="w-1/2 flex justify-center items-center px-8 sticky top-0 h-screen">
            <SearchResultsDemo searchRef={searchRef} onDownloadClick={onDownloadClick} />
          </div>
        </div>
      </ScrollableFlowScreen>
    </div>
  );
}
